import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'any',
})
export class QueryNiveauPermisContratGQLService extends Query<Response> {
  document = gql`
    query ReferentielPermis {
      referentielPermis {
        code
        libelle
      }
    }
  `;
}
